module.exports = __webpack_public_path__ + "img/SuturesZoom.1b24ac67.png";